import { InternalAuditTeamPermissionDTO } from 'models/dto/internalAuditDTO';
import InternalAuditScopeDTO, { InternalAuditScopeIdsDTO } from 'models/dto/internalAuditScopeDTO';
import InternalAuditTemplateDTO from 'models/dto/internalAuditTemplateDTO';

export class InternalAuditMonitoringUpgradePreviewRequestDTO {
  sourceTaskIds!: number[];

  auditYear!: number;

  scope?: InternalAuditScopeIdsDTO;
}

export class InternalAuditMonitoringUpgradeSourceDTO {
  sourceTaskId!: number;

  versionHash!: string;

  name!: string;

  description?: string;

  ownerId?: string;

  ownerName?: string;

  assigneeId?: string;

  assigneeName?: string;

  authSchemaId?: number;

  taskTypeId?: number;

  checklistItemCount!: number;

  recurrencePattern?: string;

  instanceCount!: number;

  completedInstanceCount!: number;

  latestCompletedOn?: string;
}

export class InternalAuditMonitoringUpgradeTeamCandidateDTO {
  userId!: string;

  name?: string;

  candidateRoles!: number[];

  suggestedRole?: number;

  requiresDecision!: boolean;

  sourceTaskIds!: number[];

  rolePermissions!: InternalAuditTeamPermissionDTO[];
}

export class InternalAuditMonitoringUpgradeScopeSourceDTO {
  entityType!: number;

  entityId!: number;

  sourceTaskIds!: number[];
}

export class InternalAuditMonitoringUpgradeProcedureSourceDTO {
  sourceTaskId!: number;

  sourceName!: string;

  checklistItemCount!: number;

  assigneeId?: string;

  assigneeName?: string;
}

export class InternalAuditMonitoringUpgradeProcedureScopeItemDTO {
  entityType!: number;

  entityId!: number;

  code?: string;

  name?: string;
}

export class InternalAuditMonitoringUpgradeProcedureDTO {
  key!: string;

  name?: string;

  taskTypeId?: number;

  formName?: string;

  checklistItemCount!: number;

  sources!: InternalAuditMonitoringUpgradeProcedureSourceDTO[];

  scopeItems!: InternalAuditMonitoringUpgradeProcedureScopeItemDTO[];
}

export default class InternalAuditMonitoringUpgradePreviewDTO {
  auditYear!: number;

  suggestedName!: string;

  suggestedDescription?: string;

  suggestedAuditType!: number;

  suggestedAuthSchemaId?: number;

  authSchemaRequiresSelection!: boolean;

  sources!: InternalAuditMonitoringUpgradeSourceDTO[];

  teamCandidates!: InternalAuditMonitoringUpgradeTeamCandidateDTO[];

  teamRequiresResolution!: boolean;

  proposedScope!: InternalAuditScopeDTO;

  scopeSources!: InternalAuditMonitoringUpgradeScopeSourceDTO[];

  procedures!: InternalAuditMonitoringUpgradeProcedureDTO[];

  sourcesWithoutScope!: number[];

  suggestedRecurrencePattern?: string;

  recurrenceCompatible!: boolean;

  warnings!: string[];

  existingInternalAuditTemplateId?: number;

  existingInternalAuditId?: number;
}

export class InternalAuditMonitoringUpgradeSourceVersionDTO {
  sourceTaskId!: number;

  versionHash!: string;
}

export class InternalAuditMonitoringUpgradeRequestDTO {
  clientRequestId!: string;

  template!: InternalAuditTemplateDTO;

  sources!: InternalAuditMonitoringUpgradeSourceVersionDTO[];

  scope!: InternalAuditScopeIdsDTO;

  auditYear!: number;
}

export class InternalAuditMonitoringUpgradeResultDTO {
  internalAuditTemplateId!: number;

  internalAuditId!: number;

  existing!: boolean;

  warnings!: string[];
}

export class InternalAuditMonitoringSourceDTO {
  sourceTaskId!: number;

  name!: string;

  upgradedOn!: string;

  auditYear!: number;

  deactivationResult!: number;

  completedInstanceCount!: number;

  latestCompletedOn?: string;
}
